import { render } from "./SellPanel.vue?vue&type=template&id=12cf6496&ts=true"
import script from "./SellPanel.vue?vue&type=script&lang=ts"
export * from "./SellPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__